import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getSportsBySlug, sports } from '../data/sports';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { KeyDetailsBlock } from '../components/KeyDetailsBlock';
import { ImageGallery } from '../components/ImageGallery';
import { RelatedPages } from '../components/RelatedPages';
export function SportsDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const sport = slug ? getSportsBySlug(slug) : undefined;
  if (!sport) return <Navigate to="/sports" replace data-id="element-1260" />;
  const otherSports = sports.filter(s => s.id !== sport.id).slice(0, 3).map(s => ({
    title: s.name,
    image: s.image,
    link: `/sports/${s.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-1261">
      <PageBanner title={sport.name} eyebrow="Sports & Wellness" image={sport.image} data-id="element-1262" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-1263">
        <Breadcrumbs items={[{
        label: 'Sports & Wellness',
        path: '/sports'
      }, {
        label: sport.name
      }]} data-id="element-1264" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-8" data-id="element-1265">
          <div className="lg:col-span-2 space-y-12" data-id="element-1266">
            <section data-id="element-1267">
              <h2 className="text-3xl mb-6" data-id="element-1268">Overview</h2>
              <p className="text-lg text-club-ink/80 leading-relaxed" data-id="element-1269">
                {sport.longDesc}
              </p>
            </section>

            <section data-id="element-1270">
              <h2 className="text-3xl mb-6" data-id="element-1271">Gallery</h2>
              <ImageGallery images={sport.images} data-id="element-1272" />
            </section>
          </div>

          <div className="space-y-8" data-id="element-1273">
            <KeyDetailsBlock details={sport.keyDetails} data-id="element-1274" />

            <div className="bg-white p-8 border border-club-border rounded-sm text-center" data-id="element-1275">
              <h3 className="font-serif text-2xl mb-4 text-club-green" data-id="element-1276">
                Book a Session
              </h3>
              <p className="text-sm text-club-ink/70 mb-6" data-id="element-1277">
                Reserve courts, tee times, or personal training sessions online.
              </p>
              <button className="btn-primary w-full" data-id="element-1278">Book Now</button>
            </div>
          </div>
        </div>

        <RelatedPages title="Other Sports Facilities" pages={otherSports} data-id="element-1279" />
      </div>
    </div>;
}